import React from 'react';

import SvgIcon from 'shell/components/SvgIcon';

const SystemAvatar = (props) => {
    return (
        <SvgIcon {...props}>
            <circle cx='12' cy='12' r='12' fill='#6347FF' />
            <path
                d='M18.8368 11.198H16.8007C16.8097 11.8432 16.6909 12.4837 16.4513 13.0823C16.2117 13.681 15.856 14.2258 15.405 14.6853C14.9539 15.1447 14.4165 15.5095 13.8239 15.7585C13.2313 16.0074 12.5954 16.1357 11.953 16.1357C11.3107 16.1357 10.6747 16.0074 10.0821 15.7585C9.48951 15.5095 8.95209 15.1447 8.50105 14.6853C8.05001 14.2258 7.69435 13.681 7.45474 13.0823C7.21513 12.4837 7.09635 11.8432 7.10529 11.198H4C4 11.214 4 11.2301 4 11.2471C3.99932 13.0009 4.56991 14.7068 5.62472 16.1044C6.67952 17.5021 8.1606 18.5147 9.84193 18.9877C11.5233 19.4608 13.3125 19.3683 14.9366 18.7243C16.5607 18.0804 17.9304 16.9204 18.8368 15.4214L18.8575 15.3865C19.6072 14.1372 20.0023 12.7057 20 11.2471C20 11.2301 20 11.214 20 11.198H18.8368Z'
                fill='white'
            />
            <path
                d='M11.9815 11.2224L12.0219 11.1979H16.8053C16.8142 10.5527 16.6954 9.91222 16.4558 9.31357C16.2162 8.71491 15.8606 8.17006 15.4095 7.71065C14.9585 7.25125 14.4211 6.88645 13.8285 6.63746C13.2359 6.38847 12.5999 6.26025 11.9576 6.26025C11.3152 6.26025 10.6793 6.38847 10.0867 6.63746C9.49406 6.88645 8.95664 7.25125 8.5056 7.71065C8.05456 8.17006 7.6989 8.71491 7.4593 9.31357C7.21969 9.91222 7.1009 10.5527 7.10984 11.1979H11.9411L11.9815 11.2224Z'
                fill='white'
            />
        </SvgIcon>
    );
};

export default SystemAvatar;
